<template>
  <div>
    <h1 class="title has-text-centered">Love Stuff</h1>

    <p class="notification is-info has-text-centered">
      <span class="has-text-weight-semibold">NB:</span> This is not about my love life!!
    </p>

    <div class="columns is-multiline">
      <div v-for="post in posts" :key="post.id" class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="card post-preview" @click="openModal(post)">
          <div class="card-content">
            <h2 class="title is-4">{{ post.title }}</h2>
            <p class="subtitle is-6">{{ post.excerpt }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Posts -->
    <div class="modal" v-if="isModalOpen" @click.self="closeModal">
      <div class="modal-content" ref="modalContent">
        <span class="close" @click="closeModal">&times;</span>
        <div v-if="currentPost">
          <h2>{{ currentPost.title }}</h2>
          <p>{{ currentPost.fullText }}</p>
        </div>
        <button @click="prevPost" class="nav-button prev">&lt;</button>
        <button @click="nextPost" class="nav-button next">&gt;</button>
      </div>
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs';
export default {
  name: 'LoveLifePage',
  data() {
    return {
      posts: [
        {
    id: 1,
    title: 'The Color of Love',
    excerpt: 'She guessed my favorite color on her first try...',
    fullText: 'When she asked me to say my favorite color, I told her to give it a guess. She said "yellow," and I was amazed when I told her she was right. The smile on her face when she heard this was priceless, and since then, I’ve never seen yellow the same again. I could probably live in it now.'
  },
 {
    id: 2,
    title: 'A Mother’s First Love',
    excerpt: 'Losing the first love I ever knew...',
    fullText: 'My mother was my first love, so pure and true, But life took her away, and I was left to rue. Her love was a beacon that guided my way, Now memories of her light fill my heart every day. <span style="font-size: 0.7rem;">True Story</span>'
  },
  {
    id: 3,
    title: 'Moonlit Memories',
    excerpt: 'A glass of wine under the moonlight...',
    fullText: 'A glass of wine beneath the moon’s gentle glow, Reminds me of her eyes, a soft, sparkling show. As I sip and reflect on moments we shared, Her gaze in the moonlight is a love that’s declared.'
  },
  {
    id: 4,
    title: 'Unseen Glances',
    excerpt: 'Watching her when she wasn’t aware...',
    fullText: 'I’d steal glances when she wasn’t aware, Her beauty a secret I held with care. In the quiet of moments when she was alone, I’d cherish her grace, a love gently shown.'
  },
  {
    id: 5,
    title: 'Endless Love',
    excerpt: 'Love that transcends physical separation...',
    fullText: 'Love never truly ends, even when bodies part, It lingers in memories, etched deep in the heart. Though physically apart, our souls remain intertwined, In every beat of my heart, your love I still find.'
  },
  {
    id: 6,
    title: 'Stranger’s Knowledge',
    excerpt: 'Passing a stranger who seems to know me...',
    fullText: 'It’s sad to think that today on the street, I passed a stranger who knew my life’s beat. A person who knows me without ever a word, Reminds me of a connection that feels so unheard.'
  },
  {
    id: 7,
    title: 'A Lost Compliment',
    excerpt: 'A comment that’s both candid and true...',
    fullText: 'She once said I was good, a compliment so rare, In the art of giving head, I’d shown my care. Though she’s gone, and we’ve drifted apart, Her praise remains, a whisper to my heart.'
  },
  {
    id: 8,
    title: 'To All the Girls Who Loved Me',
    excerpt: 'A message to those who’ve shown affection...',
    fullText: 'To all the girls who loved me, here’s my plea, If you care for me, please let it be. I might not notice if you don’t say it out loud, Yet, in my heart, your love is unbowed.'
  }    ],
     isModalOpen: false,
      currentPost: null,
      currentIndex: 0
    };
  },
  methods: {
    openModal(post) {
      this.currentPost = post;
      this.currentIndex = this.posts.findIndex(p => p.id === post.id);
      this.isModalOpen = true;

      // Initialize Hammer.js
      this.$nextTick(() => {
        const element = this.$refs.modalContent;
        const hammer = new Hammer(element);

        hammer.on('swipeleft', this.nextPost);
        hammer.on('swiperight', this.prevPost);
      });
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentPost = null;
    },
    nextPost() {
      if (this.currentIndex < this.posts.length - 1) {
        this.currentIndex += 1;
        this.currentPost = this.posts[this.currentIndex];
      }
    },
    prevPost() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.currentPost = this.posts[this.currentIndex];
      }
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 2rem;
  margin-bottom: 20px;
}

.post {
  margin-bottom: 20px;
}

.post-preview {
  cursor: pointer;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.post-preview:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.post-title {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.post-excerpt {
  font-size: 1rem;
  color: #666;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  background-color: black;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  animation: fadeIn 0.3s ease;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.modal-content p {
  font-size: 1rem;
  line-height: 1.5;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}
.nav-button {
  background: rgba(0, 123, 255, 0.5); /* Adjust the alpha value (0.5) for transparency */
  border: none;
  color: white;
  padding: 10px;
  border-radius: 1px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.nav-button.prev {
  left: 0px;
}

.nav-button.next {
  right: 0px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
